export type { TRestrictedCode } from './types';
export { useCourseRestriction } from './use-course-restriction';
